<button mat-ripple class="rounded p-0 overflow-hidden" [ngClass]="{
    'min-w-8': size() === 'big',
    'min-w-[12px] h-[12px] w-[12px]': size() === 'small',
    'min-w-[16px] h-[16px] w-[16px]': size() === 'medium',
    'min-w-[17px] h-[16px] w-[17px]': size() === 'big',
}"
        [appCopyToClipboardCopied]="value()">
    <mat-icon [class]="'cursor-pointer ' + currentColor()" [ngClass]="{
        '!w-[12px] !h-[12px] !text-[12px]': size() === 'small',
        '!w-[16px] !h-[16px] !text-[16px]': size() === 'medium',
        '!w-[17px] !h-[16px] !text-[17px]': size() === 'big'
    }" svgIcon="copy-icon"></mat-icon>
</button>
